// extracted by mini-css-extract-plugin
module.exports = {"zeroResultsMessage":"styles_zeroResultsMessage__3piD0","title":"styles_title__BsyEF"};